import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

const api = axios.create({
    baseURL: apiUrl,
});

// Retry configuration
const MAX_RETRIES = 3;
const RETRY_DELAY = 1000;

api.interceptors.response.use(
    response => response,

    async error => {
        const config = error.config;
        if (!config) {
            return Promise.reject(error);
        }

        config.retryCount = config.retryCount || 0;
        const status = error.response?.status;
        // Retry only:
        // - network error
        // - 5xx server error
        const shouldRetry = !status || status >= 400;

        if (shouldRetry && config.retryCount < MAX_RETRIES) {

            config.retryCount++;
            await new Promise(resolve =>
                setTimeout(resolve, RETRY_DELAY)
            );

            return api(config);
        }

        /*
          All retries failed

          No response means:
          - internet disconnected
          - API server unreachable

          5xx means:
          - backend problem
        */

        if (!error.response || status >= 400) {

            window.dispatchEvent(
                new CustomEvent(
                    "globalApiError",
                    {
                        detail:{
                            type: !error.response
                                ? "NETWORK"
                                : "SERVER"
                        }
                    }
                )
            );

        }


        return Promise.reject(error);

    }
);


export default api;